import { render } from "./TableColumnForm.vue?vue&type=template&id=c98d05c6&scoped=true&ts=true"
import script from "./TableColumnForm.vue?vue&type=script&lang=ts"
export * from "./TableColumnForm.vue?vue&type=script&lang=ts"

import "./TableColumnForm.vue?vue&type=style&index=0&id=c98d05c6&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c98d05c6"]])

export default __exports__